<template>
  <svg
    :x="x"
    :y="y"
    :width="width"
    :height="height"
    preserveAspectRatio="none"
    :viewBox="viewBox"
  >
    <line
      x1="0"
      :y1="heightVisual / 2 - grid.distanceHorizontalSmall"
      :x2="widthVisual"
      :y2="heightVisual / 2 - grid.distanceHorizontalSmall"
      stroke="white"
      stroke-width="0.15"
    />
    <line
      x1="0"
      :y1="heightVisual / 2 + grid.distanceHorizontalSmall"
      :x2="widthVisual"
      :y2="heightVisual / 2 + grid.distanceHorizontalSmall"
      stroke="white"
      stroke-width="0.15"
    />

    <line
      x1="0"
      :y1="heightVisual / 2 - 3 * grid.distanceHorizontalSmall"
      :x2="widthVisual"
      :y2="heightVisual / 2 - 3 * grid.distanceHorizontalSmall"
      stroke="white"
      stroke-width="0.15"
    />
    <line
      x1="0"
      :y1="heightVisual / 2 + 3 * grid.distanceHorizontalSmall"
      :x2="widthVisual"
      :y2="heightVisual / 2 + 3 * grid.distanceHorizontalSmall"
      stroke="white"
      stroke-width="0.15"
    />
    <!-- Horizontal lines outer -->
    <line
      x1="0"
      :y1="heightVisual / 2 - grid.distanceHorizontalWide"
      :x2="widthVisual"
      :y2="heightVisual / 2 - grid.distanceHorizontalWide"
      stroke="white"
      stroke-width="0.15"
    />
    <line
      x1="0"
      :y1="heightVisual / 2 + grid.distanceHorizontalWide"
      :x2="widthVisual"
      :y2="heightVisual / 2 + grid.distanceHorizontalWide"
      stroke="white"
      stroke-width="0.15"
    />
    <!-- Vertical lines outer -->
    <line
      :x1="widthVisual * (1 / 3)"
      :y1="heightVisual / 2 - grid.distanceHorizontalWide"
      :x2="widthVisual * (1 / 3)"
      :y2="heightVisual / 2 + grid.distanceHorizontalWide"
      stroke="white"
      stroke-width="0.15"
    />
    <line
      :x1="widthVisual * (2 / 3)"
      :y1="heightVisual / 2 - grid.distanceHorizontalWide"
      :x2="widthVisual * (2 / 3)"
      :y2="heightVisual / 2 + grid.distanceHorizontalWide"
      stroke="white"
      stroke-width="0.15"
    />
  </svg>
</template>
<script>
export default {
  name: 'Grid',
  props: {
    x: {
      type: Number,
      required: true,
    },
    y: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
  },
  data: function() {
    return {
      widthVisual: 700,
      heightVisual: 280,
      grid: {
        distanceHorizontalSmall: 20,
        distanceHorizontalWide: 140,
      },
    }
  },
  computed: {
    viewBox: function() {
      return [0, 0, this.widthVisual, this.heightVisual].join(' ')
    },
  },
}
</script>
